import controller_0 from 'vite-plugin-symfony/stimulus/helpers/react/render_controller';

export default [
{
        enabled: true,
        fetch: "eager",
        identifier: "symfony--ux-react--react",
        controller: controller_0
      }
];
